import React, {Component} from 'react';
import Armut from '../images/armut.png';
import Freelancer from '../images/freelancer.png';

class menu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="w-full mt-6">
                <ul className="text-xl">
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="https://medium.com/@kmlaydin">blog</a></li>
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="http://www.github.com/kemalaydin">github</a></li>
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="http://www.twitter.com/archysenos">twitter</a></li>
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="http://www.instagram.com/archysenos">instagram</a></li>
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="https://armut.com/hizmetveren/kemal-aydin-kayseri-melikgazi-web-tasarim-ve-programlama_56286">
                        <img src={Armut} style={{height: "20px"}} className="inline" /> armut</a>
                    </li>
                    <li><a className="hover:text-yellow-900 hover:text-black p-1" href="https://www.freelancer.com/u/archysenos">
                        <img src={Freelancer} style={{height: "16px"}} className="inline" /> freelancer</a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default menu;